import { render, staticRenderFns } from "./GlobalQueue.vue?vue&type=template&id=13deb99d"
import script from "./GlobalQueue.vue?vue&type=script&lang=js"
export * from "./GlobalQueue.vue?vue&type=script&lang=js"
import style0 from "./GlobalQueue.vue?vue&type=style&index=0&id=13deb99d&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports